var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEiraLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 141,
    viewBox: "0 0 178 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2478_1208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6355 103.474L52.8466 111.28H33L33.0062 110.796H33.6115C35.2869 110.796 36.6462 109.441 36.6772 107.758V80.6975C36.6772 79.1416 35.2125 77.9278 33.628 77.9278H33.0248L33.0165 77.4482H47.0065C49.0702 77.4294 51.8261 76.9476 52.7123 76.5681V82.6704L52.2289 82.6641V81.8028C52.2289 80.2699 51.0431 79.0165 49.5495 78.9247H39.7904V93.8657H47.8803C49.1632 93.8407 50.1961 92.7854 50.1961 91.484V90.7728L50.663 90.7665V98.4143L50.1961 98.408V97.6969C50.1961 96.4122 49.1901 95.3673 47.9299 95.3152H39.7904V109.795H46.6553C51.7269 109.795 53.675 107.147 55.1542 103.466H55.6355V103.474Z",
    fill: "url(#paint0_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5237 111.28H62.0498L62.056 110.797H62.6613C64.3367 110.797 65.696 109.441 65.727 107.758V80.9501C65.6857 79.2754 64.3305 77.9302 62.6613 77.9302H62.056L62.0498 77.4464H72.5216L72.5133 77.9302H71.908C70.243 77.9302 68.8898 79.2691 68.8423 80.9397V107.758C68.8733 109.441 70.2326 110.797 71.908 110.797H72.5133L72.5195 111.28H72.5237Z",
    fill: "url(#paint1_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0663 77.4393C98.7143 77.4393 102.402 80.9305 102.402 86.1986C102.402 91.4667 98.9065 95.7672 94.279 95.7484C98.3797 100.166 101.396 103.79 106.806 109.54C111.737 114.808 116.572 119.784 122.643 119.013V119.497C114.896 121.576 109.391 117.419 104.269 111.524C101.97 108.875 94.5207 100.622 91.393 97.0727C90.2216 95.7442 89.3333 94.8495 88.5152 94.7369V94.2906C88.7569 94.2906 89.856 94.3678 91.0583 94.2718C93.1118 94.1071 97.3281 93.692 98.5263 89.2456C98.671 88.7138 98.861 87.7962 98.8135 86.3467C98.6709 82.2402 96.8034 79.0014 92.8783 78.9742H86.9245V107.761C86.9431 109.35 88.2343 110.8 90.0068 110.8H90.5976L90.6038 111.284H80.1465L80.1547 110.8H80.7662C82.3404 110.8 83.772 109.553 83.8237 107.782V80.9743C83.7927 79.2912 82.4334 77.9356 80.758 77.9356H80.1527L80.1465 77.4434H93.0704L93.0663 77.4393Z",
    fill: "url(#paint2_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.396 107.754C141.365 109.904 143.135 110.797 144.602 110.797H145V111.28H134.221V110.801H134.64C135.876 110.801 137.158 109.702 136.46 107.768L133.399 99.5366H120.504L117.297 107.797C116.622 109.712 117.897 110.801 119.128 110.801H119.549V111.28H109.914V110.797H110.346C111.802 110.797 113.571 109.906 114.54 107.758L125.396 81.753C125.396 81.753 127.168 77.8384 127.168 76.7748H127.598L140.396 107.754ZM132.859 98.085L127.09 82.5747L121.068 98.085H132.859Z",
    fill: "url(#paint3_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0389 124.714V125.179H34.8014V129.14H34.2354V125.179H33V124.714H36.0389Z",
    fill: "url(#paint4_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1669 129.14L39.0244 127.334H38.4088V129.14H37.8428V124.714H39.2868C39.7847 124.714 40.1565 124.835 40.4065 125.075C40.6544 125.315 40.7783 125.634 40.7783 126.032C40.7783 126.391 40.6792 126.681 40.4809 126.902C40.2825 127.121 39.9933 127.259 39.6173 127.313L40.8114 129.14H40.171H40.1669ZM38.4088 126.919H39.2352C39.8776 126.919 40.1999 126.635 40.1999 126.064C40.1999 125.492 39.8797 125.211 39.2352 125.211H38.4088V126.919Z",
    fill: "url(#paint5_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2776 128.116H43.3502L42.9825 129.138H42.373L43.9947 124.794H44.6352L46.2506 129.138H45.6412L45.2735 128.116H45.2776ZM45.1165 127.672L44.3149 125.436L43.5134 127.672H45.1165Z",
    fill: "url(#paint6_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4749 129.14H50.9089L48.6344 125.644V129.14H48.0684V124.714H48.6344L50.9089 128.216V124.714H51.4749V129.14Z",
    fill: "url(#paint7_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2489 128.575C56.1498 128.755 55.999 128.9 55.7965 129.015C55.5941 129.128 55.342 129.184 55.0445 129.184C54.7471 129.184 54.4971 129.13 54.2719 129.024C54.0447 128.915 53.8649 128.769 53.7307 128.583C53.5964 128.396 53.5179 128.185 53.4972 127.945H54.1004C54.1149 128.07 54.1562 128.193 54.2285 128.314C54.3008 128.433 54.4041 128.531 54.5384 128.609C54.6727 128.686 54.8359 128.723 55.0259 128.723C55.2739 128.723 55.4639 128.656 55.5982 128.523C55.7304 128.39 55.7965 128.219 55.7965 128.008C55.7965 127.829 55.749 127.683 55.656 127.568C55.5631 127.455 55.4494 127.366 55.311 127.301C55.1747 127.234 54.9888 127.165 54.7512 127.09C54.4744 126.998 54.2513 126.911 54.0839 126.83C53.9166 126.748 53.774 126.625 53.6542 126.462C53.5365 126.3 53.4766 126.085 53.4766 125.816C53.4766 125.587 53.5323 125.384 53.6418 125.207C53.7513 125.032 53.9083 124.896 54.1149 124.798C54.3194 124.702 54.5611 124.654 54.84 124.654C55.2718 124.654 55.6126 124.761 55.8647 124.971C56.1167 125.184 56.2634 125.451 56.3047 125.778H55.6953C55.6622 125.603 55.5734 125.447 55.4288 125.313C55.2842 125.18 55.0859 125.113 54.838 125.113C54.6107 125.113 54.4269 125.174 54.2905 125.292C54.1542 125.411 54.086 125.58 54.086 125.797C54.086 125.968 54.1314 126.108 54.2203 126.214C54.3091 126.321 54.4207 126.404 54.5529 126.467C54.6851 126.527 54.8669 126.594 55.1003 126.671C55.3813 126.763 55.6106 126.85 55.782 126.936C55.9535 127.019 56.1002 127.144 56.22 127.315C56.3398 127.484 56.3997 127.71 56.3997 127.989C56.3997 128.198 56.3502 128.394 56.251 128.573L56.2489 128.575Z",
    fill: "url(#paint8_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6638 125.069C62.0108 125.336 62.2525 125.697 62.3847 126.16H61.7898C61.6782 125.866 61.4964 125.632 61.2485 125.459C60.9986 125.286 60.6949 125.198 60.3334 125.198C60.0462 125.198 59.7921 125.269 59.5649 125.409C59.3397 125.549 59.1599 125.749 59.0298 126.01C58.8976 126.27 58.8335 126.579 58.8335 126.929C58.8335 127.28 58.8997 127.58 59.0298 127.839C59.1599 128.097 59.3376 128.3 59.5649 128.437C59.79 128.577 60.0462 128.648 60.3334 128.648C60.6949 128.648 60.9986 128.56 61.2485 128.387C61.4964 128.214 61.6762 127.98 61.7898 127.686H62.3847C62.2525 128.147 62.0129 128.51 61.6638 128.775C61.3167 129.042 60.8746 129.173 60.3395 129.173C59.9284 129.173 59.5669 129.077 59.2508 128.888C58.9368 128.698 58.691 128.433 58.5154 128.091C58.3398 127.751 58.251 127.361 58.251 126.927C58.251 126.493 58.3398 126.097 58.5154 125.753C58.691 125.409 58.9368 125.144 59.2508 124.954C59.5669 124.765 59.9284 124.669 60.3395 124.669C60.8746 124.669 61.3167 124.802 61.6638 125.067V125.069Z",
    fill: "url(#paint9_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9529 125.179V126.691H66.6179V127.131H64.9529V128.675H66.8039V129.14H64.3848V124.714H66.8039V125.179H64.9529Z",
    fill: "url(#paint10_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.181 129.14H71.615L69.3405 125.644V129.14H68.7744V124.714H69.3405L71.615 128.216V124.714H72.181V129.14Z",
    fill: "url(#paint11_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7582 128.095C77.5805 128.426 77.3182 128.683 76.9711 128.867C76.6261 129.048 76.2088 129.14 75.7254 129.14H74.333V124.714H75.7254C76.2109 124.714 76.6261 124.804 76.9711 124.981C77.3161 125.158 77.5785 125.413 77.7582 125.747C77.9358 126.078 78.0247 126.472 78.0247 126.923C78.0247 127.373 77.9358 127.761 77.7582 128.095ZM76.9938 128.178C77.2975 127.882 77.4483 127.463 77.4483 126.923C77.4483 126.383 77.2975 125.963 76.998 125.665C76.6963 125.367 76.2604 125.217 75.6841 125.217H74.9011V128.625H75.6841C76.2542 128.625 76.6922 128.477 76.9938 128.178Z",
    fill: "url(#paint12_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.497 124.714V125.179H84.2595V129.14H83.6935V125.179H82.4561V124.714H85.4949H85.497Z",
    fill: "url(#paint13_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4061 124.948C90.7304 125.14 90.9866 125.411 91.1746 125.755C91.3605 126.101 91.4534 126.491 91.4534 126.925C91.4534 127.359 91.3605 127.751 91.1746 128.097C90.9886 128.441 90.7304 128.71 90.4061 128.902C90.0797 129.094 89.714 129.192 89.3091 129.192C88.9042 129.192 88.5344 129.096 88.2059 128.902C87.8775 128.71 87.6192 128.441 87.4333 128.097C87.2474 127.751 87.1523 127.361 87.1523 126.925C87.1523 126.489 87.2474 126.101 87.4333 125.755C87.6192 125.411 87.8775 125.142 88.2059 124.948C88.5365 124.756 88.9042 124.66 89.3091 124.66C89.714 124.66 90.0817 124.756 90.4061 124.948ZM88.4972 125.402C88.2576 125.542 88.0716 125.742 87.9374 126.005C87.8031 126.266 87.7349 126.572 87.7349 126.925C87.7349 127.277 87.8031 127.578 87.9374 127.84C88.0716 128.105 88.2576 128.306 88.4972 128.447C88.7348 128.587 89.0054 128.656 89.3091 128.656C89.6128 128.656 89.8751 128.585 90.1127 128.443C90.3523 128.301 90.5383 128.099 90.6726 127.836C90.8068 127.576 90.875 127.271 90.875 126.923C90.875 126.575 90.8068 126.266 90.6726 126.003C90.5383 125.74 90.3523 125.54 90.1127 125.4C89.8751 125.261 89.6066 125.19 89.3091 125.19C89.0116 125.19 88.7348 125.261 88.4972 125.4V125.402Z",
    fill: "url(#paint14_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9257 124.714V125.179H97.6883V129.14H97.1222V125.179H95.8848V124.714H98.9236H98.9257Z",
    fill: "url(#paint15_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.053 129.14L101.91 127.334H101.295V129.14H100.729V124.714H102.173C102.67 124.714 103.042 124.835 103.292 125.075C103.54 125.315 103.664 125.634 103.664 126.032C103.664 126.391 103.565 126.681 103.367 126.902C103.168 127.121 102.879 127.259 102.503 127.313L103.697 129.14H103.057H103.053ZM101.292 126.919H102.119C102.761 126.919 103.084 126.635 103.084 126.064C103.084 125.492 102.763 125.211 102.119 125.211H101.292V126.919Z",
    fill: "url(#paint16_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.161 128.116H106.234L105.866 129.138H105.257L106.879 124.794H107.519L109.134 129.138H108.525L108.157 128.116H108.161ZM108 127.672L107.199 125.436L106.397 127.672H108Z",
    fill: "url(#paint17_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36 129.14H113.794L111.519 125.644V129.14H110.953V124.714H111.519L113.794 128.216V124.714H114.36V129.14Z",
    fill: "url(#paint18_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.034 130L119.152 129.103C118.946 129.161 118.733 129.191 118.518 129.191C118.111 129.191 117.743 129.095 117.415 128.901C117.086 128.709 116.828 128.44 116.642 128.096C116.456 127.749 116.361 127.359 116.361 126.923C116.361 126.488 116.456 126.1 116.642 125.753C116.828 125.409 117.086 125.14 117.415 124.946C117.745 124.755 118.113 124.659 118.518 124.659C118.923 124.659 119.291 124.755 119.615 124.946C119.939 125.138 120.196 125.409 120.384 125.753C120.569 126.1 120.662 126.49 120.662 126.923C120.662 127.357 120.569 127.756 120.384 128.1C120.198 128.444 119.939 128.711 119.613 128.899L120.751 129.998H120.034V130ZM117.146 127.841C117.281 128.106 117.467 128.306 117.706 128.448C117.944 128.588 118.214 128.657 118.518 128.657C118.822 128.657 119.084 128.586 119.322 128.444C119.561 128.302 119.747 128.1 119.882 127.837C120.016 127.576 120.084 127.272 120.084 126.923C120.084 126.575 120.016 126.267 119.882 126.004C119.747 125.743 119.561 125.541 119.322 125.401C119.084 125.261 118.816 125.19 118.518 125.19C118.221 125.19 117.944 125.261 117.706 125.401C117.467 125.541 117.281 125.741 117.146 126.004C117.012 126.267 116.944 126.571 116.944 126.923C116.944 127.276 117.012 127.576 117.146 127.839V127.841Z",
    fill: "url(#paint19_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.206 124.714V127.369C123.206 127.805 123.301 128.124 123.493 128.333C123.683 128.539 123.945 128.643 124.282 128.643C124.619 128.643 124.873 128.539 125.059 128.331C125.245 128.122 125.338 127.801 125.338 127.371V124.716H125.904V127.371C125.904 127.974 125.755 128.426 125.459 128.729C125.164 129.031 124.765 129.184 124.269 129.184C123.774 129.184 123.381 129.031 123.086 128.729C122.79 128.424 122.642 127.974 122.642 127.371V124.716H123.208L123.206 124.714Z",
    fill: "url(#paint20_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.589 124.714V129.14H128.022V124.714H128.589Z",
    fill: "url(#paint21_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.305 128.694H132.859V129.138H130.739V124.713H131.305V128.692V128.694Z",
    fill: "url(#paint22_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.247 124.714V129.14H134.681V124.714H135.247Z",
    fill: "url(#paint23_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.083 124.714V125.179H138.845V129.14H138.279V125.179H137.042V124.714H140.081H140.083Z",
    fill: "url(#paint24_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 124.714L143.564 127.463V129.138H142.992V127.463L141.55 124.714H142.209L143.285 126.856L144.355 124.714H145.002H145Z",
    fill: "url(#paint25_linear_2478_1208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2966 65.0869C72.5258 65.0869 60.5088 52.9552 60.5088 38.0435C60.5088 23.1317 72.5258 11 87.2966 11C102.067 11 114.087 23.1317 114.087 38.0435C114.087 52.9552 102.07 65.0869 87.2966 65.0869ZM78.2544 61.8063C81.1425 62.9346 84.1834 63.5061 87.2966 63.5061C91.1908 63.5061 94.9258 62.626 98.4006 60.8887C99.1216 58.409 99.4872 55.8437 99.4872 53.2576C99.4872 52.7884 99.4748 52.3275 99.448 51.8645C95.1489 51.5266 90.9243 50.1585 87.1975 47.8957C83.6277 49.9437 79.5766 51.0886 75.4511 51.2138C75.5626 54.9136 76.5274 58.5654 78.2544 61.8043V61.8063ZM64.6095 49.1512C67.041 54.2045 71.0549 58.3005 76.0378 60.8136C74.7239 57.8125 73.9823 54.5173 73.8831 51.2159C70.7182 51.1241 67.5347 50.4171 64.6074 49.1512H64.6095ZM101.024 51.9479C101.043 52.3796 101.053 52.8176 101.053 53.2555C101.053 55.5038 100.797 57.7186 100.289 59.848C103.873 57.6728 106.858 54.6404 108.986 51.0073C106.621 51.6392 104.179 51.9583 101.716 51.9583C101.487 51.9583 101.254 51.9542 101.024 51.9458V51.9479ZM100.906 50.3629C101.177 50.3733 101.448 50.3796 101.718 50.3796C104.549 50.3796 107.346 49.9291 110.033 49.0427C111.682 45.6036 112.519 41.9038 112.519 38.0435C112.519 35.0924 112.021 32.1976 111.035 29.4405C107.707 27.5406 103.929 26.4749 100.08 26.3518C99.9562 30.5125 98.822 34.6044 96.7954 38.2166C99.0637 41.8788 100.481 46.0687 100.906 50.3629ZM75.228 26.4498C76.6183 39.1989 86.6666 49.1282 99.3178 50.2628C97.9275 37.5221 87.8813 27.5906 75.228 26.4498ZM63.6757 46.9509C66.8158 48.5964 70.336 49.5203 73.8831 49.6308C74.0091 45.4243 75.168 41.2907 77.2463 37.6451C75.2486 34.156 74.036 30.3582 73.6393 26.3497C73.3646 26.3393 73.0877 26.3351 72.8171 26.3351C69.8671 26.3351 66.979 26.819 64.2252 27.7721C62.7977 31.013 62.0726 34.4667 62.0726 38.0455C62.0726 41.1197 62.6118 44.1166 63.6716 46.953L63.6757 46.9509ZM78.1904 39.1759C76.5129 42.3877 75.573 45.9832 75.4531 49.6308C79.0291 49.512 82.5576 48.5776 85.7039 46.9175C82.7476 44.8549 80.1653 42.1937 78.1883 39.1759H78.1904ZM87.9825 29.2215C91.0193 31.1799 93.7111 33.7597 95.8121 36.7296C97.4648 33.5449 98.3944 29.9765 98.5121 26.3518C94.8473 26.4728 91.2238 27.4592 87.9825 29.2215ZM75.0978 24.8481C79.0952 25.1672 82.9067 26.3247 86.4269 28.2893C90.1041 26.1099 94.271 24.8961 98.5121 24.7689C98.4006 21.0128 97.4069 17.3026 95.6282 14.0115C92.9633 13.0626 90.1599 12.5809 87.2966 12.5809C83.4624 12.5809 79.7852 13.4318 76.3642 15.1065C75.4986 17.7927 75.0606 20.5998 75.0606 23.455C75.0606 23.9242 75.073 24.3872 75.0999 24.8481H75.0978ZM100.08 24.7689C103.534 24.869 106.972 25.6949 110.091 27.1673C107.571 21.7928 103.162 17.3902 97.8159 14.9083C99.2021 17.9929 99.981 21.3777 100.08 24.7689ZM74.4243 16.168C70.5344 18.4872 67.3653 21.7949 65.1962 25.8054C67.6608 25.1067 70.2224 24.7543 72.8192 24.7543C73.0547 24.7543 73.2902 24.7584 73.5216 24.7668C73.503 24.333 73.4906 23.895 73.4906 23.4591C73.4906 20.9732 73.8025 18.5268 74.4223 16.1701L74.4243 16.168Z",
    fill: "url(#paint26_linear_2478_1208)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2478_1208",
    x1: -3.98283,
    y1: -27.6349,
    x2: 116.707,
    y2: 279.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2478_1208",
    x1: 17.0907,
    y1: -35.9122,
    x2: 137.781,
    y2: 271.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2478_1208",
    x1: 39.7591,
    y1: -44.8142,
    x2: 160.452,
    y2: 262.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2478_1208",
    x1: 63.7713,
    y1: -54.2422,
    x2: 184.464,
    y2: 253.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2478_1208",
    x1: -21.7326,
    y1: -20.6659,
    x2: 98.9595,
    y2: 286.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2478_1208",
    x1: -18.2801,
    y1: -22.0215,
    x2: 102.412,
    y2: 285.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2478_1208",
    x1: -14.477,
    y1: -23.5145,
    x2: 106.216,
    y2: 283.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2478_1208",
    x1: -9.02135,
    y1: -25.6587,
    x2: 111.669,
    y2: 281.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2478_1208",
    x1: -4.55312,
    y1: -27.412,
    x2: 116.139,
    y2: 279.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2478_1208",
    x1: 0.184091,
    y1: -29.2727,
    x2: 120.876,
    y2: 278.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2478_1208",
    x1: 4.72302,
    y1: -31.0561,
    x2: 125.415,
    y2: 276.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2478_1208",
    x1: 8.96394,
    y1: -32.7204,
    x2: 129.656,
    y2: 274.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2478_1208",
    x1: 13.6322,
    y1: -34.5557,
    x2: 134.324,
    y2: 272.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2478_1208",
    x1: 21.2264,
    y1: -37.5359,
    x2: 141.916,
    y2: 269.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2478_1208",
    x1: 25.3153,
    y1: -39.1419,
    x2: 146.005,
    y2: 268.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2478_1208",
    x1: 32.8888,
    y1: -42.1158,
    x2: 153.581,
    y2: 265.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2478_1208",
    x1: 36.3402,
    y1: -43.4714,
    x2: 157.03,
    y2: 263.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2478_1208",
    x1: 40.1412,
    y1: -44.9645,
    x2: 160.834,
    y2: 262.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2478_1208",
    x1: 45.5979,
    y1: -47.1066,
    x2: 166.29,
    y2: 260.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2478_1208",
    x1: 50.6859,
    y1: -49.1044,
    x2: 171.377,
    y2: 258.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2478_1208",
    x1: 55.8982,
    y1: -51.1527,
    x2: 176.589,
    y2: 256.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2478_1208",
    x1: 59.1907,
    y1: -52.4456,
    x2: 179.883,
    y2: 254.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2478_1208",
    x1: 61.558,
    y1: -53.3756,
    x2: 182.251,
    y2: 253.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2478_1208",
    x1: 64.973,
    y1: -54.7168,
    x2: 185.665,
    y2: 252.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2478_1208",
    x1: 68.6357,
    y1: -56.1558,
    x2: 189.328,
    y2: 251.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2478_1208",
    x1: 72.8192,
    y1: -57.7976,
    x2: 193.51,
    y2: 249.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2478_1208",
    x1: 53.3196,
    y1: -50.1382,
    x2: 174.012,
    y2: 257.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBA981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A5805D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E9CB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#C8995C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AF825C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#C6A273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C394"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2478_1208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 119,
    fill: "white",
    transform: "translate(33 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiraLogo);
export default __webpack_public_path__ + "static/media/eiraLogo.ee135632ef2c44f9456f44cc00d0a369.svg";
export { ForwardRef as ReactComponent };